import React from 'react';
import { Flex, Spinner } from '@chakra-ui/react';

const LoadingSpinner = () => {
  return (
    <Flex direction='column' align='center'>
      <Spinner
        thickness='4px'
        speed='0.65s'
        emptyColor='gray.200'
        color='blue.500'
        size='xl'
        mt={10}
      />
    </Flex>
  );
};

export default LoadingSpinner;
